var map = {
	"./ion-accordion_2.entry.js": [
		37518,
		2076,
		7518
	],
	"./ion-action-sheet.entry.js": [
		41981,
		2076,
		1981
	],
	"./ion-alert.entry.js": [
		71603,
		2076,
		1603
	],
	"./ion-app_8.entry.js": [
		82273,
		2076,
		2273
	],
	"./ion-avatar_3.entry.js": [
		19642,
		9642
	],
	"./ion-back-button.entry.js": [
		32095,
		2076,
		2095
	],
	"./ion-backdrop.entry.js": [
		72335,
		2335
	],
	"./ion-breadcrumb_2.entry.js": [
		78221,
		2076,
		8221
	],
	"./ion-button_2.entry.js": [
		47184,
		7184
	],
	"./ion-card_5.entry.js": [
		38759,
		8759
	],
	"./ion-checkbox.entry.js": [
		24248,
		4248
	],
	"./ion-chip.entry.js": [
		69863,
		9863
	],
	"./ion-col_3.entry.js": [
		51769,
		1769
	],
	"./ion-datetime-button.entry.js": [
		2569,
		2326,
		2569
	],
	"./ion-datetime_3.entry.js": [
		76534,
		2326,
		2076,
		6534
	],
	"./ion-fab_3.entry.js": [
		25458,
		2076,
		5458
	],
	"./ion-img.entry.js": [
		70654,
		654
	],
	"./ion-infinite-scroll_2.entry.js": [
		36034,
		2076,
		6034
	],
	"./ion-input-password-toggle.entry.js": [
		5196,
		2076,
		5196
	],
	"./ion-input.entry.js": [
		20761,
		8923,
		2076,
		761
	],
	"./ion-item-option_3.entry.js": [
		6492,
		2076,
		6492
	],
	"./ion-item_8.entry.js": [
		29557,
		2076,
		9557
	],
	"./ion-loading.entry.js": [
		68353,
		2076,
		8353
	],
	"./ion-menu_3.entry.js": [
		51024,
		2076,
		1024
	],
	"./ion-modal.entry.js": [
		29160,
		2076,
		9160
	],
	"./ion-nav_2.entry.js": [
		60393,
		393
	],
	"./ion-picker-column-option.entry.js": [
		68442,
		8442
	],
	"./ion-picker-column.entry.js": [
		43110,
		2076,
		3110
	],
	"./ion-picker.entry.js": [
		15575,
		5575
	],
	"./ion-popover.entry.js": [
		16772,
		2076,
		6772
	],
	"./ion-progress-bar.entry.js": [
		34810,
		4810
	],
	"./ion-radio_2.entry.js": [
		14639,
		2076,
		4639
	],
	"./ion-range.entry.js": [
		90628,
		2076,
		628
	],
	"./ion-refresher_2.entry.js": [
		10852,
		2076,
		852
	],
	"./ion-reorder_2.entry.js": [
		61479,
		2076,
		1479
	],
	"./ion-ripple-effect.entry.js": [
		24065,
		4065
	],
	"./ion-route_4.entry.js": [
		57971,
		7971
	],
	"./ion-searchbar.entry.js": [
		93184,
		2076,
		3184
	],
	"./ion-segment-content.entry.js": [
		94312,
		4312
	],
	"./ion-segment-view.entry.js": [
		54540,
		4540
	],
	"./ion-segment_2.entry.js": [
		469,
		2076,
		469
	],
	"./ion-select-modal.entry.js": [
		57101,
		7101
	],
	"./ion-select_3.entry.js": [
		78471,
		2076,
		8471
	],
	"./ion-spinner.entry.js": [
		40388,
		2076,
		388
	],
	"./ion-split-pane.entry.js": [
		42392,
		2392
	],
	"./ion-tab-bar_2.entry.js": [
		36059,
		2076,
		6059
	],
	"./ion-tab_2.entry.js": [
		5427,
		5427
	],
	"./ion-text.entry.js": [
		50198,
		198
	],
	"./ion-textarea.entry.js": [
		1735,
		8923,
		1735
	],
	"./ion-toast.entry.js": [
		7510,
		2076,
		7510
	],
	"./ion-toggle.entry.js": [
		45297,
		2076,
		5297
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 88996;
module.exports = webpackAsyncContext;